/* global ace, Ladda, Mprogress */
FD.Utility = (function ($, me) {
    'use strict';

    const notify = new Notify();
    const progressBar = new Mprogress();
    me.Utility = me.Utility || {};

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */

    me.Utility.comingSoon = function () {
        const message = "This functionality is coming soon :)";
        notify.info(message, null, null, { dismissAllNotifications: true });
    };

    me.Utility.copy = function (data) {
        if (!navigator.clipboard) {
            notify.alert("Your browser doesn't support the automatic copy to clipboard functionality.");
            return;
        }

        navigator.clipboard.writeText(data.value).then(function () {
            notify.info("Copied to clipboard.");
        }, function (error) {
            notify.alert("Failed to copy to clipboard: " + error);
        });
    };

    me.Utility.createLadda = function ($button) {
        if (!$button.hasClass("ladda-button")) {
            $button.addClass('ladda-button').attr('data-style', 'expand-right').append('<span class="ladda-spinner"></span>');
        }

        // start Ladda and save to data
        return Ladda.create($button[0]);
    };

    me.Utility.startLadda = function () {
        let $laddaButton = $();

        if ($(this).is("[data-fd-control=form]")) {
            $laddaButton = $(this).control_form("popTriggerElement"); // if we are using an FD form control, the trigger element is what we want
        } else if (this.element && this.element.is("[data-fd-control=form]")) {
            if (this.element.control_form("valid")) {
                $laddaButton = this.element.control_form("popTriggerElement"); // if we are using an FD form control, the trigger element is what we want
            }
        } else {
            $laddaButton = $("[type=submit]:visible,button:not([type]):visible", this) // find any submit buttons with the "this" as the parent context
                .add($(this).filter("a,button")); // add this if it is an anchor or a button
        }

        if (!$laddaButton.length) {
            return null; // invalid "this"
        }

        // create and start Ladda
        const ladda = me.Utility.createLadda($laddaButton).start();
        $laddaButton.data("fd-ladda", ladda);
        return ladda;
    };

    me.Utility.stopLadda = function () {
        const $laddaButton = $(".ladda-button", this) // find all Laddas from the context of "this"
            .add($(this).filter(".ladda-button")); // include this in case it is an anchor or button 

        $laddaButton.each(function () {
            const ladda = $(this).data("fd-ladda");
            if (ladda) {
                $(this).prop("disabled", false);
                ladda.stop();
            }
        });
    };

    me.Utility.toggleSiblingsDisplay = function () {
        $(this).siblings().add(this).toggleClass("d-none");
    };

    me.Utility.toggleChildrenDisplay = function () {
        $(this).children().toggleClass("d-none");
    };

    me.Utility.openUrl = function (data) {
        window.open(data.value, "_blank");
    };

    me.Utility.blockUI = function (elem) {
        if (elem) {
            $(elem).block({
                message: '<i class="fa fa-fw fa-spinner fa-spin"></i>',
                overlayCSS: {
                    backgroundColor: '#fff',
                    opacity: 0.8,
                    cursor: 'wait'
                },
                css: {
                    border: 0,
                    padding: 0,
                    backgroundColor: 'transparent'
                }
            });
        } else {
            $.blockUI({
                message: '<i class="fa fa-fw fa-spinner fa-spin"></i>',
                overlayCSS: {
                    backgroundColor: '#fff',
                    opacity: 0.8,
                    cursor: 'wait'
                },
                css: {
                    border: 0,
                    padding: 0,
                    backgroundColor: 'transparent'
                }
            });
        }
    };

    me.Utility.unblockUI = function (elem) {
        if (elem) {
            $(elem).unblock();
        } else {
            $.unblockUI();
        }
    };

    me.Utility.getControlValuesByContainer = function (container) {
        const fldList = container ? $(container).find(':input,[data-name]') : $(':input,[data-name]');
        var ctrlAR = {};

        fldList.each(function () {
            var elem = $(this);
            var fldName = (elem.data('name') ? elem.data('name') : this.name).split('.').pop();
            var controlType = elem.data('fd-control');
            var val;

            if (controlType === 'select') {
                val = elem.val();
            } else if (controlType === 'number') {
                val = elem.val();
            } else if (controlType === 'checkbox' || controlType === 'toggle') {
                val = elem.is(':checked');
            } else if (controlType === 'datepicker') {
                if (elem.data("type") === 'range') {
                    val = elem.val().split('-');
                    if (val.length > 0) {
                        ctrlAR[fldName + "Start"] = val[0].trim();
                        ctrlAR[fldName + "End"] = val[1].trim();
                        return;
                    }
                }
                val = elem.val();
            } else if (elem.hasClass("btn-group") && elem.data("toggle") === "buttons") {
                val = $("label.btn-primary.active", elem).children()[0].id;
            } else if (controlType === 'button') {
                return;
            } else if (elem.is(':not(:input)')) {
                val = elem.text().trim();
            } else {
                if (elem.data('value')) {
                    val = elem.data('value');
                } else {
                    val = elem.val();
                }
            }

            ctrlAR[fldName] = val;
        });

        return ctrlAR;
    };

    me.Utility.onFailure = function (jqXhR) {
        me.Utility.stopLadda.call(this); // in case ladda is running

        switch (jqXhR.status) {
            case 400:
                notify.alert(jqXhR.getResponseHeader('error-message'));
                break;
            case 401:
                notify.alert("Unauthorized. Please refresh this page.");
                break;
            default:
                notify.alert("An error has occurred. Please try to hard refresh your page.");
                break;
        }
    };

    me.Utility.enableControls = function () {
        var self = $($(this).data("ajaxUpdate"));
        self.enableControls();
    };

    me.Utility.resetForm = function () {
        $(this).control_form('reset');
    };

    me.Utility.resetSequence = function (itemSelector) {
        let index = 0;
        $(this).children(itemSelector).each(function () {
            $('[name],[data-valmsg-for]', this).each(function () {
                updateSequance($(this), "name");
                updateSequance($(this), "data-valmsg-for");
            });
            index++;
        });

        function updateSequance($this, name) {
            if ($this.is('[' + name + ']')) {
                $this.attr(name, $this.attr(name).replace(/\[\d*\]/, '[' + index + ']'));
            }
        }
    };

    me.Utility.removeSequenceItem = function (itemSelector) {
        let parent = $(this).closest(itemSelector).parent();
        $(this).popover('dispose');
        $(this).closest("form").addClass("dirty");
        $(this).closest(itemSelector).remove();

        me.Utility.resetSequence.call(parent, itemSelector);
    };

    me.Utility.addSequenceItem = function (templateSelector, insertBeforeSelector, sequenceItemSelector, dataFdValue, inputDataFdValueSelector) {
        const item = $(templateSelector)
            .clone()
            .attr('data-fd-value', dataFdValue)
            .removeAttr('id')
            .insertBefore(insertBeforeSelector)
            .removeClass('d-none')
            .enableControls();
        item.find(inputDataFdValueSelector).prop("disabled", false).val(dataFdValue); // if this is a sequence item, there should be a hidden input for form to post the sequence
        item.closest("form").addClass("dirty"); // the form should be marked as dirty
        me.Utility.resetSequence.call(item.parent(), sequenceItemSelector);
        return item; // return the item for any other page specific updates
    };

    me.Utility.redirect = function (url) {
        progressBar.start();
        // persist state and clean dirty form
        $(".d-clean-none:visible").removeClass("d-clean-none");
        $(".d-dirty-none:not(:visible)").addClass("d-none");
        $("form").dirtyForms("setClean").removeClass('force-dirty');

        window.location = url;
    };

    me.Utility.dataAjaxRedirect = function (xhr, data) {
        progressBar.start();
        me.Utility.startLadda.call(this);
        me.Utility.redirect(data.url);
    };

    me.Utility.pingServer = function (callback) {
        $.fdAjax({
            url: me.Utility.pingUrl,
            isloader: false,
            callback: callback
        });
    };

    me.Utility.onPingRestored = function () {
        // stub for when / if we want to implement global code to handle when ping is restored/recovered
        return true;
    };

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return me.Utility;
}(jQuery, FD));